<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="user.FirstName + ' ' + user.LastName + ', User Management :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/users`">
                            <i class="fa fa-user"></i> Users
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/users/view/${UserId}`">
                            {{ user.FirstName }} {{ user.LastName }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        <i class="fa fa-lock"></i> Impersonate
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-lg-4 col-md-12">
                    <div class="alert alert-warning">
                        You are about to login as {{ user.FirstName }} {{ user.LastName }}
                    </div>

                    <button type="button" class="btn btn-success" v-on:click="impersonateUser()" :disabled="saving">Login as {{ user.FirstName }} {{ user.LastName }}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                saving: false,
                UserId: this.$route.params.id,
                user: {},
            }
        },

        methods: {
            getUser: function() {
                //Get the data
                this.$http
                    .get('users/impersonate/' + this.UserId)
                    .then(response => {
                        //Set all the data
                        this.user = response.data;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            impersonateUser: function() {
                //Send it
                this.$http
                .postWeb('impersonate/vue', {UserId: this.UserId})
                .then(response => {
                    this.saving = false;

                    //Return to main list?

                    this.$router.push('/', () => {
                        this.$router.go();
                    });

                })
                .catch(response => {

                });;
            }
        },
        mounted() {
            //Get the users
            this.getUser();
        }
    }
</script>
